import { PRODUCTS, detectProductNameFromPath } from './productBoundary';

const productName = detectProductNameFromPath(window.location.pathname);

// URLから判定したプロダクトのエントリだけを動的importで起動する（エントリ振り分け）。
// eMBAのみ従来どおりsrc直下のmain.tsx（as stringはembaの型グラフを取り込まないための措置）。
// eMBA以外はsrc/<プロダクト名>/main.tsxを起動する規約（productBoundary.test.tsにて担保）
if (productName === PRODUCTS.emba) {
  import('./main.tsx' as string);
} else {
  import(`./${productName}/main.tsx`);
}
